module.exports = __webpack_public_path__ + "static/media/rounded-bottom-mobile.a57d7566.svg";